import dayjs from 'dayjs';

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;
const YEAR_MS = 365 * DAY_MS;

/**
 * Elapsed time in shorthand: `now`, `45m`, `10h`, `3d`, `2w`, `1y`.
 *
 * A notification row gives the timestamp one small cell, so the label is a
 * number and one unit letter. Weeks run up to a year: `mo` next to `m` reads as
 * minutes at a glance.
 */
export const formatShortTimeAgo = (elapsedMs: number): string => {
  if (!Number.isFinite(elapsedMs)) return '';

  // A clock a few seconds ahead of the server must not read as a future time.
  const elapsed = Math.max(elapsedMs, 0);

  if (elapsed < MINUTE_MS) return 'now';
  if (elapsed < HOUR_MS) return `${Math.floor(elapsed / MINUTE_MS)}m`;
  if (elapsed < DAY_MS) return `${Math.floor(elapsed / HOUR_MS)}h`;
  if (elapsed < WEEK_MS) return `${Math.floor(elapsed / DAY_MS)}d`;
  if (elapsed < YEAR_MS) return `${Math.floor(elapsed / WEEK_MS)}w`;
  return `${Math.floor(elapsed / YEAR_MS)}y`;
};

export const formatNotificationTime = (created_at?: string | null): string => {
  // dayjs() with no argument returns the current time, so reject empty values first.
  if (!created_at) return '';

  const date = dayjs(created_at);
  if (!date.isValid()) return '';

  return formatShortTimeAgo(dayjs().valueOf() - date.valueOf());
};
